document.addEventListener("DOMContentLoaded", () => {
    // Locate the form and its associated table
    const form = document.querySelector("form#documents_review_form")
    const documentStatusWrapper = form?.querySelector("li#claim_documents_status_input")
    const missingDocumentsSection = form?.querySelector("div#missing_documents_section")

    if (!documentStatusWrapper || !missingDocumentsSection) return

    // --- Constants ---
    const HIDDEN = "hidden"
    const DOCUMENT_STATUS_MISSING = "missing"
    const DOCUMENT_STATUS_COMPLETED = "completed"
    const DOCUMENT_STATUS_CHECKED = 'input[name="claim[documents_status]"]:checked'
    const UNIQUE_NAME_OTHER = "other"
    const DOCUMENT_TYPE_SELECT = 'select[name*="[document_type_id]"]'
    const NAME_EN_INPUT = 'input[name*="[name_en]"]'
    const NAME_AR_INPUT = 'input[name*="[name_ar]"]'
    const ROW_SELECTOR = "tr"
    const STATUS_SELECTOR = 'input[name*="[status]"]'

    // Tracks selects we've already wired up, so the MutationObserver can't
    // double-bind a node it sees twice. WeakSet avoids polluting the DOM
    // (and avoids the dataset setter, which can be picky in some envs).
    const attachedSelects = new WeakSet()

    // --- Documents status section visibility ---
    const toggleDocumentsMissingNotesVisibility = () => {
        const selectedStatus = documentStatusWrapper.querySelector(DOCUMENT_STATUS_CHECKED)

        if (!selectedStatus || selectedStatus.value !== DOCUMENT_STATUS_MISSING) {
            missingDocumentsSection.classList.add(HIDDEN)
        } else {
            missingDocumentsSection.classList.remove(HIDDEN)
        }
    }

    // --- Per-row select behaviour helpers ---
    const getRowFor = (select) => select.closest(ROW_SELECTOR)

    const getNameInputsForRow = (select) => {
        const row = getRowFor(select)
        if (!row) return {nameEnInput: null, nameArInput: null}
        return {
            nameEnInput: row.querySelector(NAME_EN_INPUT),
            nameArInput: row.querySelector(NAME_AR_INPUT),
        }
    }

    /**
     * Sync the name (EN/AR) inputs in a row to the currently-selected option.
     *
     * - No option selected     -> empty + disabled
     * - "other" selected       -> empty + enabled (user fills manually)
     *                             on initial load we keep any pre-existing value
     * - Any other option       -> filled from data-name-en / data-name-ar + disabled
     */
    const applyNameFieldsState = (select, {isInitial = false} = {}) => {
        const {nameEnInput, nameArInput} = getNameInputsForRow(select)
        if (!nameEnInput || !nameArInput) return

        const selectedOption = select.options[select.selectedIndex]

        if (!selectedOption || !selectedOption.value) {
            nameEnInput.value = ""
            nameArInput.value = ""
            nameEnInput.disabled = true
            nameArInput.disabled = true
            return
        }

        const uniqueName = selectedOption.dataset.uniqueName
        const nameEn = selectedOption.dataset.nameEn || ""
        const nameAr = selectedOption.dataset.nameAr || ""

        if (uniqueName === UNIQUE_NAME_OTHER) {
            nameEnInput.disabled = false
            nameArInput.disabled = false
            // On a user-driven change, clear so they start from a blank slate.
            // On initial setup, keep any value that was already saved.
            if (!isInitial) {
                nameEnInput.value = ""
                nameArInput.value = ""
            }
        } else {
            nameEnInput.disabled = true
            nameArInput.disabled = true
            nameEnInput.value = nameEn
            nameArInput.value = nameAr
        }
    }

    const attachRowBehavior = (select) => {
        if (attachedSelects.has(select)) return

        attachedSelects.add(select)

        select.addEventListener("change", () => applyNameFieldsState(select))
        // Apply initial state (handles pre-selected options on edit pages
        // and freshly-cloned rows added via the "Add" button).
        applyNameFieldsState(select, {isInitial: true})
    }
    const removeRow = (input) => {
        if (input.value === "pending") return

        const row = input.closest(ROW_SELECTOR)
        row.remove()
    }

    const initializeExistingRows = () => {
        missingDocumentsSection.querySelectorAll(STATUS_SELECTOR).forEach(removeRow)
        missingDocumentsSection.querySelectorAll(DOCUMENT_TYPE_SELECT).forEach(attachRowBehavior)
    }

    // --- Watch for rows added dynamically (the "Add" button) ---
    const observeNewRows = () => {
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType !== Node.ELEMENT_NODE) return
                    if (node.matches?.(DOCUMENT_TYPE_SELECT)) {
                        attachRowBehavior(node)
                    } else {
                        node.querySelectorAll?.(DOCUMENT_TYPE_SELECT)
                            .forEach(attachRowBehavior)
                    }
                })
            }
        })
        observer.observe(missingDocumentsSection, {childList: true, subtree: true})
    }

    const applyDocumentsStatus = () => {
        const status = document.querySelector(DOCUMENT_STATUS_CHECKED)?.value

        // Preserve HTML default when nothing is selected yet
        if (!status) return

        const isCompleted = status === DOCUMENT_STATUS_COMPLETED
        missingDocumentsSection.classList.toggle(HIDDEN, isCompleted)
        setSectionEnabled(!isCompleted)
    }

    const removeUnselectedDocumentTypeRows = () => {
        const status = document.querySelector(DOCUMENT_STATUS_CHECKED)?.value
        const selects = Array.from(missingDocumentsSection.querySelectorAll(DOCUMENT_TYPE_SELECT))

        const emptySelects = selects.filter((s) => !s.value)
        const hasFilledRow = selects.some((s) => s.value)

        if (status === DOCUMENT_STATUS_MISSING && !hasFilledRow) return

        emptySelects.forEach((select) => select.closest(ROW_SELECTOR)?.remove())
    }

    const setSectionEnabled = (enabled) => {
        missingDocumentsSection.querySelectorAll("input, select, textarea").forEach((el) => {el.disabled = !enabled})
    }

    const addEventListeners = () => {
        documentStatusWrapper.addEventListener("change", toggleDocumentsMissingNotesVisibility)
    }

    const addFormEventListener = () => {
            const submitButton = form.querySelector('input[type="submit"], button[type="submit"]')
            submitButton?.addEventListener("click", () => {
                removeUnselectedDocumentTypeRows()
            })
        }

    // Initialize state on page load
    toggleDocumentsMissingNotesVisibility()
    initializeExistingRows()
    observeNewRows()
    addEventListeners()
    addFormEventListener()
    applyDocumentsStatus()
})
